<template>
  <section class="installs">
    <div class="panel">
      <div class="panel-head">
        <div class="panel-heading">
          <h2 class="panel-title">ETO &amp; Inspiring Installs</h2>
          <p class="panel-sub">
            Showcase your most impressive installations, share photos, and explain the unique
            features that make them stand out.
          </p>
        </div>
        <router-link to="/eto-and-inspiring-installs" class="panel-link">
          View all <span class="material-icons">arrow_forward</span>
        </router-link>
      </div>

      <div class="panel-body">
        <!-- Loading -->
        <div v-if="loading" class="row" aria-busy="true">
          <div v-for="n in 2" :key="n" class="col-12 col-lg-6 install-col">
            <div class="install-skeleton">
              <div class="sk sk-img"></div>
              <div class="sk sk-line"></div>
              <div class="sk sk-line short"></div>
            </div>
          </div>
        </div>

        <!-- Error -->
        <div v-else-if="error" class="panel-empty">
          <span class="material-icons">cloud_off</span>
          <p class="mb0">
            We couldn't load installs.
            <a href="#" @click.prevent="getPosts">Try again</a>
          </p>
        </div>

        <!-- Empty -->
        <div v-else-if="!featured.length" class="panel-empty">
          <span class="material-icons">photo_library</span>
          <p class="mb0">
            No installs shared yet.
            <router-link to="/eto-and-inspiring-installs">Share the first one</router-link>
          </p>
        </div>

        <!-- Cards -->
        <div v-else class="row">
          <div v-for="install in featured" :key="install.ItemID" class="col-12 col-lg-6 install-col">
            <install-card :Install="install" />
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import axios from "axios";
import InstallCard from "./InstallCardSmallNew.vue";

export default {
  name: "HomeInstalls",
  components: { InstallCard },
  data() {
    return {
      server: import.meta.env.VITE_APP_SERVER_URL,
      loading: true,
      error: false,
      posts: [],
    };
  },
  computed: {
    USERID() {
      return this.$store.state.user?.UserId;
    },
    featured() {
      return this.posts.slice(0, 2);
    },
  },
  watch: {
    // If the user loads after this component, fetch once the ID arrives
    USERID(id, oldId) {
      if (id && !oldId) this.getPosts();
    },
  },
  created() {
    if (this.USERID) this.getPosts();
  },
  methods: {
    getPosts() {
      if (!this.USERID) return;
      this.loading = true;
      this.error = false;

      return axios
        .get(`${this.server}/api/v1/cool-installs/home/${encodeURIComponent(this.USERID)}`, {
          headers: { Authorization: "Bearer " + localStorage.getItem("SSCUSER") },
        })
        .then(res => {
          const body = res.data;
          this.posts = Array.isArray(body) ? body : body?.data || [];
        })
        .catch(err => {
          console.error(err);
          // 401s are handled by the global axios interceptor (logoutOnTokenExpired)
          if (err.response?.status !== 401) this.error = true;
        })
        .finally(() => {
          this.loading = false;
        });
    },
  },
};
</script>

<style scoped>
.installs {
  margin: 20px 0;
}
.panel {
  background: #fff;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
}
.panel-head {
  display: flex;
  align-items: center;
  gap: 20px;
  padding: 16px 20px;
  border-bottom: 1px solid #eef0f2;
}
.panel-heading {
  min-width: 0;
}
.panel-title {
  font-size: 20px;
  font-weight: 600;
  color: #1e3040;
  margin: 0;
}
.panel-sub {
  color: #575757;
  font-size: 15px;
  line-height: 1.45;
  margin: 4px 0 0;
}
.panel-link {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  margin-left: auto;
  color: #429da8;
  font-weight: 500;
  white-space: nowrap;
}
.panel-link:hover {
  color: #1e3040;
  text-decoration: none;
}
.panel-link .material-icons {
  font-size: 18px;
  transition: transform 0.2s;
}
.panel-link:hover .material-icons {
  transform: translateX(3px);
}
.panel-body {
  padding: 20px 20px 0;
}
.install-col {
  margin-bottom: 20px;
}

/* Empty / error */
.panel-empty {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 10px 0 30px;
  color: #575757;
}
.panel-empty .material-icons {
  color: #429da8;
  font-size: 28px;
}
.panel-empty a {
  color: #429da8;
}

/* Loading skeleton */
.install-skeleton {
  border-radius: 6px;
  overflow: hidden;
}
.sk {
  background: linear-gradient(90deg, #eceff1 25%, #f6f7f8 50%, #eceff1 75%);
  background-size: 200% 100%;
  animation: sk-shimmer 1.2s infinite;
  border-radius: 4px;
}
.sk-img {
  aspect-ratio: 16 / 9;
  margin-bottom: 12px;
  border-radius: 6px;
}
.sk-line {
  height: 12px;
  margin-bottom: 10px;
}
.sk-line.short {
  width: 55%;
}
@keyframes sk-shimmer {
  from { background-position: 200% 0; }
  to { background-position: -200% 0; }
}

@media (max-width: 767px) {
  .panel-head {
    flex-direction: column;
    align-items: flex-start;
    gap: 8px;
  }
  .panel-link {
    margin-left: 0;
  }
}
.panel {
  background: #fff;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
  /* overflow: hidden;  ← remove */
}
</style>
